import moment from 'moment';

export const dateFormat = (date: moment.MomentInput) => moment(date).format('DD.MM.YYYY');

export const timeFormat = (time: moment.MomentInput) => moment(time).format('HH:mm');

export const dateTimeFormat = (date: moment.MomentInput) => moment(date).format('DD.MM.YYYY - HH:mm');
